<script setup lang="ts">
import ArrowLeftIcon from 'vue-material-design-icons/ArrowLeft.vue';

interface MenuTagChild {
  id: number;
  name: string;
  description?: string | null;
  count: number;
}

interface MenuTagGroup {
  id: number;
  name: string;
  recipe_tags: MenuTagChild[];
}

defineProps<{
  menuTags: MenuTagGroup[];
}>();

const emit = defineEmits<{
  (e: 'change-tag', tagId?: number): void;
}>();

function changeTag(tagId?: number) {
  emit('change-tag', tagId);
}
</script>

<template>
  <div class="border-r border-cream-500 px-3 py-2">
    <button
      class="text-brown-300 flex mb-3 hover:underline"
      @click="changeTag()"
    >
      <ArrowLeftIcon :size="20" class="mr-1 relative bottom-[1px]" />
      <span>すべての献立</span>
    </button>

    <ul>
      <li v-for="menuTag in menuTags" :key="menuTag.id" class="mb-4">
        <p class="font-bold text-pink-400 mb-2">
          {{ menuTag.name }}
        </p>

        <ul>
          <li v-for="child in menuTag.recipe_tags" :key="child.id" class="mb-2">
            <button
              class="hover:underline text-gray-500 text-left"
              data-testid="tag-button"
              @click="changeTag(child.id)"
            >
              {{ child.name }}({{ child.count }})
            </button>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>
